import {byProp} from '@lib/utils';
import {createSelector} from '@reduxjs/toolkit';
import {RootState} from '../../rootReducer';
import {transformToBuildingIdMap} from './utils';
import createCachedSelector from 're-reselect';

export const getAllParkingLots = (state: RootState) => state.data.parkingLots.parkingLots;
export const getIsLoadingParkingLots = (state: RootState) => state.data.parkingLots.status === 'Loading';

export const getAllParkingLotsGroupedByBuilding = createCachedSelector([getAllParkingLots], (parkingLots) =>
  transformToBuildingIdMap(parkingLots),
)((state) => state.data.parkingLots.parkingLots.length);

export const getParkingLotById = createSelector(
  [getAllParkingLots, (_: RootState, id: string) => id],
  (parkingLots, id) => {
    return parkingLots.find((parkingLot) => parkingLot.id === id);
  },
);

export const getParkingLotsByBuildingId = createCachedSelector(
  [getAllParkingLotsGroupedByBuilding, (_: RootState, buildingId: string) => buildingId],
  (groupedParkingLots, buildingId: string) => groupedParkingLots.get(buildingId) || [],
)((_, buildingId) => buildingId);

export const getFilteredAndSortedParkingLots = createCachedSelector(getParkingLotsByBuildingId, (parkingLots) => {
  return parkingLots.filter((parkingLot) => parkingLot.capacity > 0).sort(byProp('name'));
})((state, buildingId) => buildingId);
